export const types = {
  authLogin: "[Auth] Login",
  logout: "[Auth] Logout",
  recoveryPass: "[Auth] Recovery Password",
  cleanRecoveryPass: "[Auth] Clean Recovery Password",

  showSidebar: "[UI] Show SideBar",
  toggleSidebar: "[UI] Toggle SideBar",
  toggleForm: "[UI] Toggle Form Auth",
  itemSelect: "[UI] Items Select",


  addInfo: "[Bussines] Add Info for Bussines",
  loadInfo: "[Bussines] Load Info for Bussines",
  addMoreInfo: "[Bussines] Add More Info for Bussines",
  addFileImg: "[Bussines] Add image for Bussines",


  addNewIntership: "[Intership] Add New Intership",
  loadIntership: "[Intership] Load Interships",

  userExists: "[USER] Exists",
  userDoesnot: "[USER] Does not exist",


};
